import React, { useEffect, useState } from 'react';
import api from 'api';
import { API } from 'common/config-api';

/**
 * 상품 카테고리 설정 페이지
 */
const CategorySettings = () => {
  const apiUrl = `${API.BASE_URL}`;

  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingName, setEditingName] = useState('');

  // 카테고리 목록 조회
  const getCategories = async () => {
    try {
      const response = await api.get(`${apiUrl}/common/code/category`);
      setCategories(response || []);
    } catch (error) {
      console.error('카테고리 조회 실패:', error);
      alert('카테고리 조회 중 오류가 발생했습니다.');
    }
  };

  // 카테고리 추가
  const handleAdd = async () => {
    if (!newCategory.trim()) {
      alert('카테고리명을 입력해주세요.');
      return;
    }

    try {
      await api.post(`${apiUrl}/common/code/category`, { name: newCategory });
      setNewCategory('');
      getCategories();
      alert('카테고리가 추가되었습니다.');
    } catch (error) {
      console.error('카테고리 추가 실패:', error);
      alert('카테고리 추가에 실패했습니다.');
    }
  };

  // 카테고리 수정
  const handleEdit = async (id) => {
    if (!editingName.trim()) {
      alert('카테고리명을 입력해주세요.');
      return;
    }

    try {
      await api.put(`${apiUrl}/common/code/category/${id}`, { name: editingName });
      setEditingId(null);
      setEditingName('');
      getCategories();
      alert('카테고리가 수정되었습니다.');
    } catch (error) {
      console.error('카테고리 수정 실패:', error);
      alert('카테고리 수정에 실패했습니다.');
    }
  };

  // 카테고리 삭제
  const handleDelete = async (id, name) => {
    if (!window.confirm(`"${name}" 카테고리를 삭제하시겠습니까?`)) {
      return;
    }

    try {
      await api.delete(`${apiUrl}/common/code/category/${id}`);
      getCategories();
      alert('카테고리가 삭제되었습니다.');
    } catch (error) {
      console.error('카테고리 삭제 실패:', error);
      alert('카테고리 삭제에 실패했습니다.');
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">상품 카테고리 설정</h5>

            {/* 카테고리 추가 */}
            <div className="row mb-4">
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  placeholder="새 카테고리명 입력"
                  value={newCategory}
                  onChange={(e) => setNewCategory(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                />
              </div>
              <div className="col-sm-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAdd}
                >
                  추가
                </button>
              </div>
            </div>

            {/* 카테고리 목록 */}
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col" width="10%">#</th>
                  <th scope="col" width="50%">카테고리명</th>
                  <th scope="col" width="20%">상품 수</th>
                  <th scope="col" width="20%">관리</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category, index) => (
                  <tr key={category.id}>
                    <td>{index + 1}</td>
                    <td>
                      {editingId === category.id ? (
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={editingName}
                          onChange={(e) => setEditingName(e.target.value)}
                          onKeyDown={(e) => e.key === 'Enter' && handleEdit(category.id)}
                        />
                      ) : (
                        category.name
                      )}
                    </td>
                    <td>{category.count || 0}개</td>
                    <td>
                      {editingId === category.id ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-success btn-sm me-1"
                            onClick={() => handleEdit(category.id)}
                          >
                            저장
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                              setEditingId(null);
                              setEditingName('');
                            }}
                          >
                            취소
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm me-1"
                            onClick={() => {
                              setEditingId(category.id);
                              setEditingName(category.name);
                            }}
                          >
                            수정
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(category.id, category.name)}
                          >
                            삭제
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategorySettings;
